
import { defineComponent, ref, Suspense } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Logo from '@/components/Icons/Logo.vue'
import Trophy from '@/components/Icons/Trophy.vue'
import BlueButton from '@/components/Buttons/BlueButton.vue'

import { challengeDataAPI } from '@/proxies/challengeData/challengeData'

export default defineComponent({
  name: 'SuccessCard',
  components: { Logo, Trophy, BlueButton },
  async setup() {
    const { go, push } = useRouter()
    const {
      params: { id },
    } = useRoute()
    const challenge = ref(await challengeDataAPI.getChallengeData(id as string))

    const getHeadingGreeting = () => {
      if (challenge.value.experience >= 2000) return `Excelente!`
      if (challenge.value.experience >= 500) return `Parabéns!`
      if (challenge.value.experience < 500) return `Que pena`
    }

    const getMessage = () => {
      if (challenge.value.experience >= 2000)
        return `Você fez <strong>${challenge.value.experience}</strong> pontos. Impressionante!`
      if (challenge.value.experience >= 500)
        return `Você fez <strong>${challenge.value.experience}</strong> pontos.`
      if (challenge.value.experience < 500)
        return `Você fez apenas <strong>${challenge.value.experience}</strong> pontos.`
    }

    return {
      heading: getHeadingGreeting(),
      message: getMessage(),
      challenge,
      Suspense,
      go,
      push,
    }
  },
})
